import { Form, Field, TextInput, Dropdown } from '@carboledger/ui';
import { useTranslations } from '@/hooks';

/**
 * Props:
 *   formOptions  useValidateDeclarationFormOptions() result
 */
export const CertificationScopeSection = ({ formOptions }) => {
  const t = useTranslations();

  return (
    <Form.Section title={t('SECTION_CERTIFICATION_SCOPE')}>
      <Form.Row columns={1}>
        <Field name="sustainabilityCriteriaCompliance" required>
          {({ id, name, value, onChange, onBlur, status, message, required }) => (
            <Dropdown
              id={id}
              name={name}
              label={t('FIELD_SUSTAINABILITY_CRITERIA_COMPLIANCE')}
              placeholder={t('COMMON_SELECT')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
              required={required}
              options={formOptions.yesNoOptions}
            />
          )}
        </Field>
      </Form.Row>

      <Form.Row columns={1}>
        <Field name="intermediateCrop">
          {({ id, name, value, onChange, onBlur, status, message }) => (
            <Dropdown
              id={id}
              name={name}
              label={t('FORM_INTERMEDIATE_CROP')}
              placeholder={t('COMMON_SELECT')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
              options={formOptions.yesNoOptions}
              searchable
              searchPlaceholder={t('COMMON_SEARCH')}
              noResultsMessage={t('COMMON_NO_MATCHES')}
            />
          )}
        </Field>
      </Form.Row>

      <Form.Row columns={1}>
        <Field name="lowIlucRiskFeedstock">
          {({ id, name, value, onChange, onBlur, status, message }) => (
            <Dropdown
              id={id}
              name={name}
              label={t('FORM_LOW_ILUC_RISK_FEEDSTOCK')}
              placeholder={t('COMMON_SELECT')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
              options={formOptions.yesNoOptions}
              searchable
              searchPlaceholder={t('COMMON_SEARCH')}
              noResultsMessage={t('COMMON_NO_MATCHES')}
            />
          )}
        </Field>
      </Form.Row>

      <Form.Row columns={1}>
        <Field name="wasteOrResidueDefinition" required>
          {({ id, name, value, onChange, onBlur, status, message, required }) => (
            <Dropdown
              id={id}
              name={name}
              label={t('FIELD_WASTE_OR_RESIDUE_DEFINITION')}
              placeholder={t('COMMON_SELECT')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
              required={required}
              options={formOptions.yesNoOptions}
            />
          )}
        </Field>
      </Form.Row>

      <Form.Row columns={1}>
        <Field name="wasteOrByProductPermitNumber">
          {({ id, name, value, onChange, onBlur, status, message }) => (
            <TextInput
              id={id}
              name={name}
              label={t('FORM_WASTE_OR_BY_PRODUCT_PERMIT_NUMBER')}
              placeholder={t('FORM_PERMIT_NUMBER_PLACEHOLDER')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
            />
          )}
        </Field>
      </Form.Row>

      <Form.Row columns={1}>
        <Field name="productionSupportReceived" required>
          {({ id, name, value, onChange, onBlur, status, message, required }) => (
            <Dropdown
              id={id}
              name={name}
              label={t('FIELD_PRODUCTION_SUPPORT_RECEIVED')}
              placeholder={t('COMMON_SELECT')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
              required={required}
              options={formOptions.yesNoOptions}
            />
          )}
        </Field>
      </Form.Row>

      <Form.Row columns={1}>
        <Field name="supportNatureAndScheme">
          {({ id, name, value, onChange, onBlur, status, message }) => (
            <TextInput
              id={id}
              name={name}
              label={t('FORM_SUPPORT_NATURE_AND_SCHEME')}
              placeholder={t('FORM_PERMIT_NUMBER_PLACEHOLDER')}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              status={status}
              message={message}
            />
          )}
        </Field>
      </Form.Row>
    </Form.Section>
  );
};
